module.exports = __webpack_public_path__ + "images/icons/icon-large-left-arrow-242f5857.svg";